import { render, staticRenderFns } from "./ConfigMwxTemplate.vue?vue&type=template&id=46bc68ea"
import script from "./ConfigMwxTemplate.vue?vue&type=script&lang=js"
export * from "./ConfigMwxTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports